import React, { memo } from "react";
import styles from "./GetSolarPower.module.scss";
import { BigLogo, Logo } from "../../../assets/icons";
import { useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../routes";

type Props = {};

const GetSolarPower: React.FC<Props> = memo((props: Props) => {
	const navigate = useNavigate();

	function navigateToRecommendation() {
		navigate(ApplicationRoutes.RECOMMENDATION);
	}

	return (
		<div className={styles.container}>
			<div className={styles.content}>
				<div className={styles.titleContainer}>
					<div className={styles.title}>Enjoy Clean, Affordable Energy without the Hassle</div>
					<div className={styles.subtitle}>
					  Seamless solutions for your power needs. Simple, reliable and stress-free.
					</div>
				</div>
				{/* <button className={styles.btn} onClick={navigateToRecommendation}>
					<Logo />
					Get Solar Power
				</button> */}
				<BigLogo className={styles.img} />
			</div>
		</div>
	);
});

export default GetSolarPower;
